import { CloudUpload } from '@mui/icons-material';
import { IconButton, List, TextField, Typography } from '@mui/material';
import { acceptedUploadFileTypes, translations } from '../../lib';
import DocumentItem from './DocumentItem';

export type DocumentGroupProps = {
    uploadedDocList: any;
    group: any;
    addFilesHandler: (field: string, event: any, documentId: number) => void;
    deleteFileHandler: (option: string) => void;
};

const DocumentGroup = ({ uploadedDocList, group, addFilesHandler, deleteFileHandler }: DocumentGroupProps) => {
    const { id, naziv, opis, obavezan } = group;
    return (
        <div key={id}>
            <List sx={{ paddingBottom: 0, paddingTop: 0 }}>
                <Typography sx={{ color: '#0000009c', fontWeight: '600' }} paddingTop={4}>
                    {naziv}
                    {obavezan ? ' *' : ''}:
                </Typography>
                {opis ? <Typography>{opis}</Typography> : null}
                {uploadedDocList.length !== 0 &&
                    uploadedDocList.map((file: any, index: any) => {
                        if (file.field.includes(naziv)) {
                            return (
                                <DocumentItem
                                    uploadedFile={file}
                                    index={index}
                                    key={`${file.field}-${index}`}
                                    deleteFileHandler={deleteFileHandler}
                                />
                            );
                        }
                    })}
            </List>
            <TextField
                variant="outlined"
                disabled={true}
                style={{ background: 'gray', borderRadius: '5px', width: '100%' }}
                InputProps={{
                    startAdornment: (
                        <IconButton
                            id={id}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                right: '0',
                                left: '0',
                                height: '56px',
                                borderRadius: '5px',
                                margin: '0 auto',
                            }}
                        >
                            <CloudUpload color="error" style={{ fontSize: '30', marginRight: '20' }} />
                            <p
                                style={{
                                    color: 'white',
                                    textTransform: 'uppercase',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                }}
                            >
                                {translations.documentation.CHOOSE_DOC}
                            </p>
                            <input
                                accept={acceptedUploadFileTypes}
                                type="file"
                                multiple
                                style={{
                                    opacity: '0',
                                    position: 'absolute',
                                    height: '48px',
                                    cursor: 'pointer',
                                    width: '100%',
                                }}
                                onChange={(event) => {
                                    addFilesHandler(`documents.${naziv}`, event, id);
                                }}
                            />
                        </IconButton>
                    ),
                }}
            />
        </div>
    );
};

export default DocumentGroup;
